<script>
  import { ConfigsApp } from '@shopboxai/sb-configs-app';
  import { userToken } from '../stores';
</script>

<ConfigsApp user={JSON.stringify($userToken)} />
